import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	CompanyPortal,
	CompanyPortalModel,
	CompanyPortalParams,
} from 'domain/usecases/public/sign-in/company-portal';

export class RemoteCompanyPortal implements CompanyPortal {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<CompanyPortalModel>,
	) {}

	async get(params: CompanyPortalParams): Promise<CompanyPortalModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
